/**
 * Barrel for the API layer. The axios instance + token plumbing live in
 * ./api/client; each domain's request wrappers live in ./api/<domain>.
 * Re-exported here so existing `import { xxxApi } from '@/lib/api'` keep working.
 * Split out of a single 4.7k-line file — see frontend CLAUDE.md file-size rule.
 */
export * from './api/client';
export * from './api/accounts';
export * from './api/workspace';
export * from './api/workspace-core';
export * from './api/members';
export * from './api/onboarding-gate';
export * from './api/email-reports';
export * from './api/admin-s3';
export * from './api/admin-workspace';
export * from './api/adminConfig';
export * from './api/media';
export * from './api/post';
export * from './api/connection';
export * from './api/brandIntel';
export * from './api/blog';
export * from './api/content';
export * from './api/analytics';
export * from './api/billing';
export * from './api/engagement';
export * from './api/admin';
export * from './api/metrics';
export * from './api/misc';
